module.exports = __webpack_public_path__ + "img/zhiwuyuan.a4f906b5.jpg";